<template>
  <el-row>
    <el-card shadow="none"
             class="form-card mb-15">
      <el-form :inline="true"
               :model="searchForm"
               ref="search_form"
               class="search-form">
        <el-form-item label="维修人:"
                      prop="name">
          <el-input v-model.trim="searchForm.name"
                    placeholder="维修人"></el-input>
        </el-form-item>
        <el-form-item>
          <el-button type="primary"
                     icon="el-icon-search"
                     @click="searchSubmit('search_form')">查询
          </el-button>
          <el-button icon="el-icon-refresh"
                     @click="resetForm('search_form')">重置
          </el-button>
        </el-form-item>
      </el-form>
    </el-card>
    <el-row>
      <el-button v-has="'/repairman/add'"
                 type="primary"
                 @click="handleAdd">新增</el-button>
      <el-button v-has="'/repairman/batch_del'"
                 type="primary"
                 @click="multipleDelete">批量删除</el-button>
    </el-row>
    <el-card shadow="none"
             class="mt-15">
      <el-table max-height="575"
                ref="multipleTable"
                :data="tableData"
                @selection-change="handleSelectionChange">
        <el-table-column type="selection"
                         width="80"></el-table-column>
        <el-table-column v-for="(item, index) in tableTitle"
                         :fixed="item.fixed"
                         :key="index"
                         :label="item.name"
                         :prop="item.prop"
                         :min-width="item.width"
                         :show-overflow-tooltip="true">
          <template slot-scope="scope">
            <template v-if="item.prop === 'status'">
              <el-tag v-if="scope.row[item.prop] === 0"
                      type="danger">
                待维修
              </el-tag>
              <el-tag v-else
                      type="success">
                已维修
              </el-tag>
            </template>
            <span v-else>{{ scope.row[item.prop] }}</span>
          </template>
        </el-table-column>
        <el-table-column fixed="right"
                         label="操作"
                         width="150">
          <template slot-scope="scope">
            <el-button v-has="'/repairman/edit'"
                       size="mini"
                       type="primary"
                       @click="handleEdit(scope.row)">编辑
            </el-button>
            <el-button v-has="'/repairman/batch_del'"
                       size="mini"
                       type="danger"
                       @click="handleDelete(scope.row)">删除
            </el-button>
          </template>
        </el-table-column>
      </el-table>
      <Pagination :total="pagination.total"
                  :pageSize="pagination.perPage"
                  @handleSizeChange="handleSizeChange"
                  @handleCurrent="handleCurrentChange"></Pagination>
    </el-card>
    <add-repairman v-if="showRepairModal"
                   :isShow="showRepairModal"
                   :data="repairData"
                   @handleClose="closeHolidayModal"></add-repairman>
  </el-row>
</template>

<script>
import fetch from '@/common/api'
import AddRepairman from '@/views/system/repair/AddRepairman'
import Pagination from '@/components/pagination/Pagination'
export default {
  components: { AddRepairman, Pagination },
  data() {
    return {
      searchForm: {
        name: ''
      },
      tableTitle: [
        {
          prop: 'name',
          name: '维修人',
          width: '80'
        },
        {
          prop: 'contact_ctx',
          name: '联系方式',
          width: '80'
        },
        {
          prop: 'contact_type',
          name: '通知方式',
          width: '100'
        }
      ],
      tableData: [],
      // 分页相关
      pagination: {
        total: 0,
        currentPage: 1,
        perPage: 10
      },
      // 选中数据
      multipleSelection: [],
      // 添加维修相关
      showRepairModal: false,
      repairData: {
        type: 'add'
      }
    }
  },
  created() {
    this.getList()
  },
  methods: {
    // 获取列表
    getList() {
      const { perPage, currentPage } = this.pagination
      fetch
        .getRepairManList({
          perPage: perPage,
          currentPage: currentPage,
          ...this.searchForm
        })
        .then((data) => {
          data.procData(
            data.res,
            (data) => {
              this.pagination.total = Number(data.total)
              this.tableData = data.list
            },
            (err) => {
              this.$message.error(err)
            }
          )
        })
    },
    // 搜索提交
    searchSubmit() {
      this.pagination.perPage = 10
      this.pagination.currentPage = 1
      this.getList()
    },
    resetForm(formName) {
      this.pagination.perPage = 10
      this.pagination.currentPage = 1
      this.$refs[formName].resetFields()
      this.getList()
    },
    // 选择变化
    handleSelectionChange(val) {
      this.multipleSelection = val
    },
    // 分页
    handleSizeChange(val) {
      this.pagination.perPage = val
      this.pagination.currentPage = 1
      this.getList()
    },
    handleCurrentChange(val) {
      this.pagination.currentPage = val
      this.getList()
    },
    // 添加假日管理
    handleAdd() {
      this.showRepairModal = true
      this.repairData = {
        type: 'add'
      }
    },
    // 批量删除
    multipleDelete() {
      if (this.multipleSelection.length > 0) {
        this.$confirm('是否确定删除选中的数据?', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        })
          .then(() => {
            let selectIds = this.multipleSelection
              .map((item) => {
                return item.id
              })
              .join(',')
            this.delRepairMan(selectIds)
          })
          .catch(() => {})
      } else {
        this.$message.warning('请选择维修人员后重试')
      }
    },
    // 编辑
    handleEdit(data) {
      this.showRepairModal = true
      this.repairData = {
        type: 'edit',
        id: data.id
      }
    },
    closeHolidayModal(type) {
      if (type === 'refresh') {
        this.getList()
      }
      this.showRepairModal = false
    },
    // 删除
    handleDelete(data) {
      this.$confirm('是否确定删除该条数据?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      })
        .then(() => {
          this.delRepairMan(data.id)
        })
        .catch(() => {})
    },
    // 删除方法
    delRepairMan(ids) {
      fetch.batchDelRepairMan({ id: ids }).then((data) => {
        data.procData(
          data.res,
          () => {
            this.getList()
            this.$message.success('操作成功')
          },
          (err) => {
            this.$message.error(err)
          }
        )
      })
    }
  }
}
</script>

<style></style>
